module.exports = __webpack_public_path__ + "google.png?88b2cd68d66cb3c44b9b060b8239324c";